import { Metadata } from 'next';

export const appConfig = {
  title: 'Nextcut Salon',
  description:
    'A modern Next.js application with Supabase, React Query, and TypeScript',
  keywords: 'next.js, supabase, react-query, typescript, boilerplate',
  logo: '/logo/main.png',
  defaultLocale: 'en-AE',
  defaultCurrency: 'AED',
  defaultCountryCode: 'AE',
  appUrl: process.env.NEXT_PUBLIC_APP_URL || 'https://partners.nxcut.com',
  emails: {
    support: 'support@example.com',
    sender: 'noreply@example.com',
  },
} as const;

export const uiConfig = {
  timeSlotHeight: 30, // in pixels
  timeSlotWidth: 150, // in pixels
  /** Sticky hour column (must match StaffHeader + CalendarContainer). */
  timeColumnWidth: 57,
};

export const businessConfig = {
  vatRate: 0.05,
};

export default function getMetadata(): Metadata {
  return {
    metadataBase: new URL(appConfig.appUrl),
    title: { template: `%s | ${appConfig.title}`, default: appConfig.title },
    description: appConfig.description,
    robots: { index: true, follow: true },
    // icons: {
    //   icon: '/favicon/favicon.ico',
    //   shortcut: '/favicon/favicon-16x16.png',
    //   apple: '/favicon/apple-touch-icon.png',
    // },
    // manifest: `/favicon/site.webmanifest`,

    openGraph: {
      url: appConfig.appUrl,
      title: appConfig.title,
      description: appConfig.description,
      siteName: appConfig.title,
      images: [`/main/logo.png`],
      type: 'website',
      locale: appConfig.defaultLocale.replace('-', '_'),
    },

    twitter: {
      card: 'summary_large_image',
      title: appConfig.title,
      description: appConfig.description,
      images: [`/main/logo.png`],
    },
    keywords: [
      'next.js',
      'supabase',
      'react-query',
      'typescript',
      'boilerplate',
      'web development',
    ],
  };
}
